export const rankarr = [
  'เลือกยศ',
  'พล.อ.อ.', 'ว่าที่ พล.อ.อ.',
  'พล.อ.อ.หญิง', 'ว่าที่ พล.อ.อ.หญิง',
  'พล.อ.ท.', 'ว่าที่ พล.อ.ท.',
  'พล.อ.ท.หญิง', 'ว่าที่ พล.อ.ท.หญิง',
  'พล.อ.ต.', 'ว่าที่ พล.อ.ต.',
  'พล.อ.ต.หญิง', 'ว่าที่ พล.อ.ต.หญิง',
  'น.อ.(พ)', 'ว่าที่ น.อ.(พ)',
  'น.อ.(พ) หญิง', 'ว่าที่ น.อ.(พ) หญิง',
  'น.อ.', 'ว่าที่ น.อ.',
  'น.อ.หญิง', 'ว่าที่ น.อ.หญิง',
  'น.ท.', 'ว่าที่ น.ท.',
  'น.ท.หญิง', 'ว่าที่ น.ท.หญิง',
  'น.ต.', 'ว่าที่ น.ต.',
  'น.ต.หญิง', 'ว่าที่ น.ต.หญิง',
  'ร.อ.', 'ว่าที่ ร.อ.',
  'ร.อ.หญิง', 'ว่าที่ ร.อ.หญิง',
  'ร.ท.', 'ว่าที่ ร.ท.',
  'ร.ท.หญิง', 'ว่าที่ ร.ท.หญิง',
  'ร.ต.', 'ว่าที่ ร.ต.',
  'ร.ต.หญิง', 'ว่าที่ ร.ต.หญิง',
  'พ.อ.อ.',
  'พ.อ.อ.(พ)',
  'พ.อ.อ.หญิง',
  'พ.อ.อ.(พ) หญิง',
  'พ.อ.ท.',
  'พ.อ.ท.หญิง',
  'พ.อ.ต.',
  'พ.อ.ต.หญิง',
  'จ.อ.',
  'จ.อ.หญิง',
  'จ.ท.',
  'จ.ท.หญิง',
  'จ.ต.',
  'จ.ต.หญิง',
  'นาย',
  'นาง',
  'นางสาว'
];

export const perscorpsarr = [
  "เลือกเหล่า",
  "ถร.",
  "ชอ.",
  "ชย.",
  "กง.",
  "สบ.",
  "ส.",
  "พธ.",
  "สพ.",
  "พ.",
  "ขส.",
  "วศ.",
  "อย.",
  "สห.",
  "พด.",
  "ดย.",
  "ผท.",
  "อต.",
  "ตห.",
];

export const persgrpsarr = [
  "เลือกจำพวก",
  "ผู้ทำการในอากาศ",
  "ยุทธการ",
  "นักบิน",
  "วิทยาศาสตร์",
  "อุตุนิยมวิทยา",
  "ควบคุมการปฏิบัติทางอากาศ",
  "นิรภัย",
  "สารสนเทศและสงครามอิเล็กทรอนิกส์",
  "สื่อสารอิเล็กทรอนิกส์",
  "สรรพาวุธ",
  "ช่างอากาศ",
  "ส่งกำลังบำรุง",
  "ช่างพาหนะ",
  "ช่างโยธา",
  "แผนที่",
  "ขนส่ง",
  "พลาธิการ",
  "พัสดุ",
  "การเงิน",
  "ปลัดบัญชี",
  "ตรวจสอบภายใน",
  "สารบรรณ",
  "ลาดตระเวนทางอากาศ",
  "กำลังพล",
  "สวัสดิการ",
  "การศึกษาและการฝึก",
  "ดุริยางค์",
  "สารวัตร",
  "อากาศโยธิน",
  "กิจการพลเรือนและประชาสัมพันธ์",
  "อนุศาสนาจารย์",
  "บริการแพทย์",
  "พยาบาล",
  "การข่าวกรอง",
  "พระธรรมนูญ",
  "ผู้ชำนาญการแพทย์เฉพาะอย่าง",
  "เภสัชกร",
  "แพทย์",
  "ทันตแพทย์",
  "ผู้บังคับอากาศยานไร้คนขับ",
  "ปฏิบัติการทางอวกาศ",
  "ไม่ระบุจำพวก",
];

export const rtafunitarr = {
  "เลือกสังกัด": "SEL",
  "ศบพ.": "AAC",
  "ศฮพ.": "HAC",
  "ศกอ.": "AWC",
  "สพร.ทอ.": "OPSD",
  "สยล.ทอ.": "OSD",//"สคม.ทอ.",
  "สลก.ทอ.": "SEC",
  "สบ.ทอ.": "DAS",
  "กพ.ทอ.": "DP",
  "ขว.ทอ.": "DI",
  "ยก.ทอ.": "DO",
  "กบ.ทอ.": "DL",
  "กร.ทอ.": "DCA",
  "ทสส.ทอ.": "DICT",
  "สปช.ทอ.": "OC",
  "กง.ทอ.": "DF",
  "จร.ทอ.": "DIG",
  "สตน.ทอ.": "RIA", //กำหนดเอง
  "สนภ.ทอ.": "SC",
  "สธน.ทอ.": "OJT",
  "ศซบ.ทอ.": "RCC",
  "สบน.ทอ.": "MAA", //กำหนดเอง
  "คปอ.": "DAOC",
  "อย.": "RTAFSFC",
  "รร.การบิน": "FTS",
  "บน.1": "WG1R", //กำหนดเอง
  "บน.2": "WG2R", //กำหนดเอง
  "บน.3": "WG3R", //กำหนดเอง
  "บน.4": "WG4R", //กำหนดเอง
  "บน.5": "WG5R", //กำหนดเอง
  "บน.6": "WG6R", //กำหนดเอง
  "บน.7": "WG7R", //กำหนดเอง
  "บน.21": "WG21R", //กำหนดเอง
  "บน.23": "WG23R", //กำหนดเอง
  "บน.41": "WG41R", //กำหนดเอง
  "บน.46": "WG46R", //กำหนดเอง
  "บน.56": "WG56R", //กำหนดเอง
  "ศปอว.ทอ.": "SPOC",
  "พธ.ทอ.": "DQ",
  "ชอ.": "DAE",
  "สอ.ทอ.": "DC&E",
  "สพ.ทอ.": "DA",
  "พอ.": "DOMS",
  "ขส.ทอ.": "DT",
  "ชย.ทอ.": "DCE",
  "ศซว.ทอ.": "SWC",
  "ยศ.ทอ.": "DET",
  "รร.นนก.": "NKRFA",
  "ศวอ.ทอ.": "RDC",
  "สก.ทอ.": "DWF", //กำหนดเอง
  "สน.ผบ.ดม.": "ODMBC",
  "สวบ.ทอ.": "IAM",
};

/* export const rtafunitarr = [
   "เลือกสังกัด",
   "ศบพ.",
   "ศฮพ.",
   "ศกอ.",
   "สพร.ทอ.",
   "สคม.ทอ.",
   "สลก.ทอ.",
   "สบ.ทอ.",
   "กพ.ทอ.",
   "ขว.ทอ.",
   "ยก.ทอ.",
   "กบ.ทอ.",
   "กร.ทอ.",
   "ทสส.ทอ.",
   "สปช.ทอ.",
   "กง.ทอ.",
   "จร.ทอ.",
   "สตน.ทอ.",
   "สนภ.ทอ.",
   "สธน.ทอ.",
   "ศซบ.ทอ.",
   "สบน.ทอ.",
   "คปอ.ทอ.",
   "อย.",
   "รร.การบิน",
   "บน.1",
   "บน.2",
   "บน.3",
   "บน.4",
   "บน.5",
   "บน.7",
   "บน.6",
   "บน.23",
   "บน.21",
   "บน.41",
   "บน.46",
   "บน.56",
   "ศปอว.ทอ.",
   "พธ.ทอ.",
   "ชอ.",
   "สอ.ทอ.",
   "สพ.ทอ.",
   "พอ.",
   "ขส.ทอ.",
   "ชย.ทอ.",
   "ศซว.ทอ.",
   "ยศ.ทอ.",
   "รร.นนก.",
   "ศวอ.ทอ.",
   "สก.ทอ.",
   "สน.ผบ.ดม.",
   "สวบ.ทอ.",
 ];
 */

export const countryarr = [
  'เลือกประเทศ',
  'เกาหลีใต้',
  'เครือรัฐบาฮามาส',
  'เครือรัฐออสเตรเลีย',
  'ญี่ปุ่น',
  'ไทย',
  'มาเลเซีย',
  'เยอรมัน',
  'รัฐสุลต่านโอมาน',
  'รัฐเอกราชปาปัวนิวกินี',
  'ราชรัฐโมนาโก',
  'ราชรัฐลักเซมเบิร์ก',
  'ราชรัฐอันดอร์รา',
  'ราชอาณาจักรกัมพูชา',
  'ราชอาณาจักรเดนมาร์ก',
  'ราชอาณาจักรนอร์เวย์',
  'ราชอาณาจักรเนเธอร์แลนด์',
  'ราชอาณาจักรโมร็อกโก',
  'ราชอาณาจักรสวาซิแลนด์',
  'ราชอาณาจักรสวีเดน',
  'โรมาเนีย',
  'ลาว',
  'เวียดนาม',
  'สหรัฐอเมริกา',
  'สหราชอาณาจักรบริเตนใหญ่และไอร์แลนด์เหนือ',
  'สาธารณรัฐฝรั่งเศส',
  'สิงคโปร์'
];